var _path, _path2, _rect, _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChatBotMessageLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 34,
    viewBox: "0 0 33 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.548 17.7484C21.7104 18.4924 19.7269 18.9513 17.6523 19.0702C17.2945 19.0907 16.934 19.1011 16.5711 19.1011C16.2082 19.1011 15.8477 19.0907 15.4899 19.0702C13.4148 18.9513 11.4309 18.4922 9.59294 17.7479C5.73588 16.1859 2.52193 13.3676 0.458496 9.80056C3.67472 4.24067 9.68607 0.5 16.5711 0.5C23.4562 0.5 29.4675 4.24067 32.6837 9.80056C30.6201 13.368 27.4056 16.1865 23.548 17.7484Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5925 19.1958C9.14816 19.0158 8.71235 18.8192 8.28585 18.6067C6.89977 19.5831 5.72802 20.7992 4.8457 22.1866C6.34541 24.5449 8.68132 26.4082 11.4846 27.4409C12.8204 27.933 14.2624 28.2365 15.7706 28.3151H17.3422C18.85 28.2365 21.5002 29.7303 17.6519 33.4999C20.4556 32.4673 26.7672 24.5452 28.267 22.1866C27.3872 20.8032 26.2197 19.59 24.8387 18.615C24.4172 18.8246 23.9865 19.0186 23.5476 19.1963C21.71 19.9403 19.7265 20.3992 17.6519 20.5181C17.2941 20.5386 16.9336 20.549 16.5707 20.549C16.2078 20.549 15.8473 20.5386 15.4895 20.5181C13.4144 20.3992 11.4304 19.9401 9.5925 19.1958Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8.80127,
    y: 7.42139,
    width: 15.573,
    height: 5.5618,
    rx: 2.7809,
    fill: "#162550"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 20.8825,
    cy: 10.1714,
    rx: 1.01966,
    ry: 1.01966,
    fill: "#04FED1"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 16.5563,
    cy: 23.8905,
    rx: 1.01966,
    ry: 1.01966,
    fill: "#162550"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.4786,
    cy: 10.1714,
    rx: 1.01966,
    ry: 1.01966,
    fill: "#04FED1"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.4786,
    cy: 23.8905,
    rx: 1.01966,
    ry: 1.01966,
    fill: "#162550"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 20.6359,
    cy: 23.8905,
    rx: 1.01966,
    ry: 1.01966,
    fill: "#162550"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatBotMessageLogo);
export default __webpack_public_path__ + "static/media/chat-bot-message-logo.d2e39dc831b06672c00d102ee216c469.svg";
export { ForwardRef as ReactComponent };